import React, { useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { StringParam, useQueryParams, withDefault, NumberParam } from 'use-query-params';
import { loaded } from '../../utils/helpers';
import { graphql, useStaticQuery } from 'gatsby';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const AU_MOBILE_PATTERN = /^(?:04\d{8}|\+?614\d{8})$/;

const isValidEmail = (email) => EMAIL_PATTERN.test(email.trim());
const isValidPhone = (phone) => AU_MOBILE_PATTERN.test(phone.replace(/[\s()-]/g, ''));

const FormNewsletter = () => {
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [validationError, setValidationError] = React.useState('');
  const emailIsValid = isValidEmail(email);
  const phoneIsValid = isValidPhone(phone);

  const {
    prismicStoreConfiguration: {
      data: { footer_newsletter_label, footer_newsletter_sub_label },
    },
  } = useStaticQuery(query);

  const [params] = useQueryParams({
    fNewsletter: withDefault(NumberParam, 0),
    result: withDefault(StringParam, ''),
    customer_posted: withDefault(StringParam, false),
  });

  useEffect(() => {
    if (params.customer_posted === 'true' && loaded) {
      location.hash = '#footer-newsletter';
    }
  }, [params]);

  return (
    <form
      id="footer-newsletter"
      action={`https://${process.env.GATSBY_SHOPIFY_DOMAIN_CHECKOUT}#contact`}
      acceptCharset="UTF-8"
      method="GET"
      className="form footer__container__subscribe__form -form-subscribe"
      onSubmit={(event) => {
        if (!emailIsValid && !phoneIsValid) {
          event.preventDefault();
          setValidationError('Please enter a valid email address or mobile number');
        }
      }}
    >
      {/* <input type="hidden" name="userid" defaultValue={269233} />
            <input type="hidden" name="SIGce9446fb862b99d2dd6ceea1023fef6fdf5f8d8c1adba3d50d78fcc6f9ddf09d" defaultValue="" />
            <input type="hidden" name="addressbookid" defaultValue={2061434} /> */}
      {/* {typeof window != `undefined` && (
        <>
          <input type="hidden" name="ReturnURL" value={`${location.origin}?fNewsletter=1`} />
          <input type="hidden" name="ci_consenturl" value={location.origin} />
        </>
      )} */}

      <div className="form__header">
        <label htmlFor="input-footer-newsletter">{footer_newsletter_label}</label>
        <p className="des-newletter">{footer_newsletter_sub_label}</p>
      </div>
      <div>
        {(params.result === 'success' && params.fNewsletter) ||
        params.customer_posted === 'true' ? (
          <p style={{ fontSize: '14px', color: '#6acac6', fontWeight: 'bold' }}>
            Hooray! You're on the a-list
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div className="form__main">
              <input
                height={25}
                id="input-footer-newsletter"
                placeholder="Enter your email here"
                name={emailIsValid ? 'email' : undefined}
                type="text"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setValidationError('');
                }}
                autoComplete="email"
                inputMode="email"
                required={!phone}
                aria-invalid={email.length > 0 && !emailIsValid}
              />
            </div>
            <div className="form__main">
              {/* <input type="hidden" name="form_type" defaultValue="customer" />
            <input type="hidden" name="utf8" defaultValue="✓" />
            <input type="hidden" name="contact[tags]" defaultValue="newsletter" /> */}
              <input
                id="input-footer-newsletter-phone"
                placeholder="Enter your mobile here"
                name={phoneIsValid ? 'phone' : undefined}
                type="tel"
                height={25}
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                  setValidationError('');
                }}
                autoComplete="tel"
                inputMode="tel"
                required={!email}
                aria-invalid={phone.length > 0 && !phoneIsValid}
              />
              <button type="submit" className="btn--subscribe">
                subscribe
              </button>
            </div>

            {validationError && (
              <span className="d-block text-danger" role="alert" aria-live="polite">
                {validationError}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="form__footer">
        <StaticImage
          width={200}
          height={27}
          sizes="200x27"
          src="../../images/payment-icons.png"
          alt="activeskin"
        />
      </div>
    </form>
  );
};

export default FormNewsletter;

const query = graphql`
  query FooterNewsletter {
    prismicStoreConfiguration {
      data {
        footer_newsletter_label
        footer_newsletter_sub_label
      }
    }
  }
`;
